module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/CircleSolidSmall.87a8ad71.svg";